import { Check, Close } from '@randstad-lean-mobile-factory/react-assets/dist/icons';
import classnames from 'classnames';
import { forwardRef } from 'react';

import { Loader } from '../../Loader/Loader.component';
import { parseMutationStatus } from '../../utils';

import styles from './Button.module.scss';
import { ButtonProps } from './Button.types';

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  (
    {
      variant = 'primary',
      size = 'xlarge',
      rounded,
      selected: focus,
      className,
      mutationStatus,
      children,
      disabled,
      ...props
    },
    ref
  ) => {
    const { isPending, isSuccess, isError } = parseMutationStatus(mutationStatus);

    return (
      <button
        data-icon-size={size === 'small' ? 'small' : 'medium'}
        className={classnames(styles.button, className, styles[variant], styles[size], {
          [styles.disabled]: disabled,
          [styles.rounded]: rounded,
          [styles.selected]: focus,
          [styles.pending]: isPending,
          [styles.success]: isSuccess,
          [styles.error]: isError,
        })}
        disabled={disabled || isPending || isSuccess || isError}
        type="button"
        {...props}
        ref={ref}
      >
        {isPending && (
          <Loader size="small" variant="secondary" className={styles.mutationIndicator} />
        )}
        {isSuccess && <Check className={styles.mutationIndicator} />}
        {isError && <Close className={styles.mutationIndicator} />}
        <span className={styles.content}>{children}</span>
      </button>
    );
  }
);
